import React from 'react'
import styled from 'styled-components'
import { getTagTextColor } from '../../utils/colorContrast'

const Tag = styled.span<{color?: string, $textColor: string}>`
  background-color: ${({color}) => color || 'gray'};
  color: ${({$textColor}) => $textColor};
  padding: .3rem .5rem;
  border-radius: .4rem;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
`

const TagComponent: React.FC<{name: string, color?: string}> = ({name, color}) => {
  const textColor = getTagTextColor(color)

  return (
    <Tag color={color} $textColor={textColor}>
      {name}
    </Tag>
  )
}

export default TagComponent